import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BuildingsLayer from '@App/components/BuildingsLayer/BuildingsLayer';
import Slider from '@library/Slider/Slider';

import { useUploadedBuildingsRecords } from '../../../../utils/queries/upload.queries'
import BuildingsCustomRadiogroup from './BuildingsCustomRadiogroup/BuildingsCustomRadiogroup';
import { setCurrentBuilding } from '../layer-selector.redux.action';

function BuildingRadios({ setbuildingSelectedValue }) {
  const dispatch = useDispatch()
  const { data: buildingRecords } = useUploadedBuildingsRecords()
  const isCreatingNewDamageLayer = useSelector(state => state.newDamageLayer.isCreatingNewDamageLayer);
  const userSelectedMode = useSelector(state => state.maplibreMap.userSelectedMode);

  const radios = [
    { label: 'Ljubljana building set', value: 'default' },
    ...(buildingRecords?.map?.(building => ({
      label: building.name,
      value: building.id,
    })) ?? []),
  ];

  const currentSelectedBuilding = useSelector(state => state.layerSelector.currentSelectedBuilding)
  const [buildingsLayerOpacityLevel, setBuildingsLayerOpacityLevel] = useState(1)
  const map = useSelector(state => state.maplibreMap.map);
  
  useEffect(() => {
    setBuildingsLayerOpacityLevel(1)
    if (setbuildingSelectedValue) setbuildingSelectedValue(currentSelectedBuilding)
  }, [setbuildingSelectedValue, currentSelectedBuilding])

  return (
    <div>
      <div>
        <BuildingsCustomRadiogroup
          radios={radios}
          selectedValue={currentSelectedBuilding || 'default'}
          onChange={e => dispatch(setCurrentBuilding(e))}
          css={{
            fontSize: '14px',
          }}
        />
        {(!isCreatingNewDamageLayer || userSelectedMode === 'Flash flood') && (
          <div className="layer-selector__opacity-slider__wrapper">
            <span>Opacity:</span>
            <Slider
              currentValue={buildingsLayerOpacityLevel}
              onInputChange={setBuildingsLayerOpacityLevel}
            />
          </div>
        )}
        
      </div>
  
      {map && (
        <BuildingsLayer map={map} opacity={buildingsLayerOpacityLevel} selectedValue={currentSelectedBuilding} />
      )}
    </div>
  )
}

export default BuildingRadios